
<template> 
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn  icon dark :disabled="submitLoading" @click="close()">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="editData.CropWorkActivityID > 0">Edit Activity</span>
                <span v-else>Add New Activity</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md10 offset-md1 mt-4>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field label="Activity Code" ref="ActivityCodeField" v-model="editData.ActivityCode" counter="25" :rules="codeRules"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field label="Description" v-model="editData.Description" counter="100" :rules="requiredRule"></v-text-field>
                        </v-flex>
                        <v-select :items="departmentCodes" label="Department Codes" 
                             v-model="editData.Departments" item-value="CropWorkDepartmentCodeID" item-text="ActivityDepartmentCode"
                             return-object multiple :rules="requiredRule" clearable>
                             <v-btn slot="prepend-item" color="primary" @click="selectAllDepartments">Select all</v-btn>
                            <v-divider
                                slot="prepend-item"
                                class="mt-2"/>
                        </v-select>
                        <v-flex xs12>
                            <v-card-title>
                                Units Of Measure
                                <v-spacer></v-spacer>
                                <v-checkbox
                                    v-model="filterIsActive"
                                    label="Active Only">
                                </v-checkbox>
                                <v-btn 
                                    color="primary" 
                                    block 
                                    @click="addUMO()">
                                    <span>Add</span>
                                </v-btn>
                            </v-card-title>
                                
                            <v-data-table :headers="headers" :items="filteredUnitOfMeasures" hide-actions dense>
                                <template v-slot:items="{ item }">
                                        <td>
                                            <div v-if="true" :id="`UOM_${item.ActivityUnitID}`">
                                                <v-text-field                                                
                                                v-model="item.UnitOfMeasure"
                                                label="UOM"
                                                single-line
                                                @keydown.enter="focusNext(item.ActivityUnitID)"
                                            ></v-text-field>
                                            </div>
                                        <span v-else>{{item.UnitOfMeasure}}</span>
                                    </td>
                                    <td>
                                        <v-checkbox
                                            class="grid-checkbox"
                                            :input-value="item.IsActive"
                                            @change="activeUMO(item)"
                                        >
                                        </v-checkbox>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-flex>

                        <v-flex xs12>
                            <v-switch hide-details :label="editData.Status ? 'Active' : 'Inactive'" v-model="editData.Status"></v-switch>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox hide-details label="Require Division" v-model="editData.RequireDivision"></v-checkbox>
                            <v-checkbox hide-details label="Require Location" v-model="editData.RequireLocation"> </v-checkbox>
                            <v-checkbox hide-details label="Require Product" v-model="editData.RequireProduct"> </v-checkbox>
                            <v-checkbox hide-details label="Require Variety" v-model="editData.RequireVariety"> </v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn block color="success" :disabled="!editValid || !umoAreValid()" :loading="submitLoading" @click="submit">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn block color="error" :disabled="submitLoading" @click="close()">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert :value="error != null" outline type="error">
                                <span>{{ error }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</template>

<script>

import {
    mapState
} from 'vuex';
import cropworkActivityApi from '@/api/cropworkActivityApi';

export default {
    components: {
    },
    props: [    
        'loading',
        'editData'
    ],
    data(){
        return {
            editValid: false,
            index: 0,
            error: null,
            submitLoading: false,
            codeRules: [v => v.length <= 25 || 'Max 25 characters', v => v.length > 0 || 'Required'],
            requiredRule: [v => v.length > 0 || 'Required'],
            departments: [{id: 1, text: 'To Do'}],
            unitSearch: null,
            filterIsActive: true,
            headers: [
                {
                    text: "Unit Of Measure",
                    value: "UnitOfMeasure",
                    sortable: false    
                },
                {
                    text: "Active",
                    value: "IsActive",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        ...mapState("CropWorkStore", [
            "departmentCodes",
        ]),
        plantID() {
            return this.$route.params.plantID;
        },
        unitOfMeasures() {
            return this.editData != null ? this.editData.Units : [];
        },
        filteredUnitOfMeasures() {
            return this.filterIsActive ? this.unitOfMeasures.filter(u=> u.IsActive) : this.unitOfMeasures;
        }
    },
    watch: {
        unitSearch(value) {

            if(value && value.length > 10) {
                this.unitSearch = value.slice(0,9)
            }
        }
    },
    created() {
        // set focus on the first field 
        this.$nextTick(()=>{
            // wait for next tick so references are mapped & not undefined
            this.$refs.ActivityCodeField.focus();
        });
    },
    methods: {
        removeUnit (item) {
            console.log(item)
            this.editData.Units.splice(this.editData.Units.indexOf(item), 1)
            this.editData.Units = [...this.editData.Units]
        },
        close(){
            this.error = null; 
            this.$emit("close");
        },
        async submit(){
            console.log(this.editData);
            try {
                this.submitLoading=true
               
                var data = this.editData;
                
                const res = await cropworkActivityApi.saveActivity(data);
                if(res.Success){
                    this.close();
                    await this.$store.dispatch("CropWorkStore/loadCropWorkActivitiesAsync", { plantID: this.plantID });
                }
                else {
                    // display error msg
                    this.error = res.ErrorMessages.join(', '); 
                }
            } 
            catch(e) {
                this.error = e;
            }
            finally {
                this.submitLoading = false;
            }
        },
        addUMO() {
            let min = -1;
            this.editData.Units.forEach(unit => {
                if (unit.ActivityUnitID <= min) {
                    min = min - 1;
                }
            });

            this.editData.Units.push({ActivityUnitID: min, ActivityID: -1, UnitOfMeasure: "", Editing: true, IsActive: true});
        },
        activeUMO(item) {
            item.IsActive = !item.IsActive;
        },
        umoAreValid() {
            if(this.unitOfMeasures.filter(u=> u.IsActive).length == 0) {
                return false;
            }
            if([...new Set(this.unitOfMeasures.map(u=> u.UnitOfMeasure))].length != this.unitOfMeasures.length) {
                return false
            }
            if(this.unitOfMeasures.some(u=> u.UnitOfMeasure === '')) {
                return false;
            }
            return true;
        },
        selectAllDepartments() {
            this.editData.Departments = this.departmentCodes;
        },
        focusNext(activityUnitID) {
            let next = false;

            this.editData.Units.forEach(unit => {
                if (next === true) {
                    next = unit.ActivityUnitID;
                }

                if (unit.ActivityUnitID === activityUnitID) {
                    next = true;
                }
            });

            const element = this.$el.querySelector('#UOM_' + next + ' input');
            if (element) {
                element.focus();
            }
        }
    }
}
</script>